import React, { useEffect, useState } from 'react'
import styles from "./style.module.css"
import { Tabs, TabList, TabPanels, Tab, TabPanel, InputGroup, Input, InputRightElement, Button } from '@chakra-ui/react'
import { BiSearch } from 'react-icons/bi'
import Overview from './Overview/Overview'
import HistoryAd from './HistoryAd/HistoryAd'
import CreateAd from './CreateAd/CreateAd'
import { useDispatch, useSelector } from 'react-redux'
import { fetchPartnerAdData } from '../../../Redux/Advertisement/Partner/PartnerAdReducer'

import Filter from './Filter'
const initialFilter = {
    isApproved: false,
    isRequested: false,
    isRejected: false,

}
const PartnerAd = () => {
    const [filter, setFilter] = useState(initialFilter)
    const [createAd, setCreateAd] = useState(false)
    const [search, setSearch] = useState("")
    const [page, setPage] = useState(1)
    const [type, setType] = useState("Overview")
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [filterApplied, setFilterApplied] = useState(false)
    const dispatch = useDispatch()
    const ads = useSelector(store => store.PartnerAdReducer.partnerAd.data) || []
    const { overViewCount, historyCount } = useSelector(store => store.PartnerAdReducer.partnerAd)
    const total = useSelector(store => store.PartnerAdReducer.partnerAd.totalData)
    const loading = useSelector(store => store?.PartnerAdReducer?.isLoading) || false

    function getStatusString(obj) {
        if (obj.isApproved && obj.isRequested && obj.isRejected) {
            return 'status=Requested&&status=Requested&&status=approved';
        }
        else if (obj.isApproved && obj.isRequested) {
            return 'status=Requested&&status=approved';
        }
        else if (obj.isRequested && obj.isRejected) {
            return 'status=Requested&&status=Requested';
        }
        else if (obj.isApproved && obj.isRejected) {
            return 'status=Requested&&status=approved';
        }
        else if (obj.isApproved) {
            return 'status=Requested'
        } else if (obj.isRequested) {
            return 'status=Requested';
        } else if (obj.isRejected) {
            return 'status=Rejected';
        } else {
            return '';
        }
    }

    useEffect(() => {
        const url = getStatusString(filter)
        dispatch(fetchPartnerAdData(type, search, page, url, startDate, endDate))


    }, [type, search, dispatch, page, filterApplied])

    if (createAd) {
        return (
            <CreateAd setCreateAd={setCreateAd} />
        )
    }
    return (
        <div className={styles.MainContainer}>
            <div className={styles.firstDiv}>
                <h1>Advertisement</h1>

                <div className={styles.filterDiv}>
                    <InputGroup w={200}>
                        <Input placeholder='Search' onChange={(e) => setSearch(e.target.value)} />
                        <InputRightElement>
                            <BiSearch color='green.500' />
                        </InputRightElement>
                    </InputGroup>
                    <Filter setType={setType} setFilter={setFilter} filter={filter} setEndDate={setEndDate} endDate={endDate} setStartDate={setStartDate} startDate={startDate} setFilterApplied={setFilterApplied} filterApplied={filterApplied} />

                    <Button bg="#8CC9E9" onClick={() => setCreateAd(true)}>Create New Advertisement</Button>
                </div>

            </div>
            <div>
                <Tabs>
                    <TabList>
                        <Tab className={styles.tabPanel} onClick={() => setType("Overview")}>Overview <span id={type === "Overview" ? styles.activeTab : null} className={styles.numberSpan}>{overViewCount ? overViewCount : 0}</span></Tab>
                        &nbsp;
                        &nbsp;
                        &nbsp;

                        <Tab className={styles.tabPanel} onClick={() => setType("History")}>History <span id={type === "History" ? styles.activeTab : null} className={styles.numberSpan}>{historyCount ? historyCount : 0}</span></Tab>

                    </TabList>

                    <TabPanels>
                        <TabPanel>
                            <Overview ads={ads} setPage={setPage} total={total} page={page} loading={loading}/>
                        </TabPanel>
                        <TabPanel>
                            <HistoryAd ads={ads} setPage={setPage} total={total} page={page} loading={loading}/>
                        </TabPanel>

                    </TabPanels>
                </Tabs>
            </div>
        </div>
    )
}

export default PartnerAd